import localeNl from '@angular/common/locales/nl';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { AppComponent } from 'app/components/app/app.component';
import { CacheRouteReuseStrategy } from 'app/routing/route-reuse-strategy';
import { ApiInterceptor } from 'app/services/api/api.service';
import { environment } from 'environments/environment';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { routes } from 'app/routing/routes';
import { DateFnsModule } from 'ngx-date-fns';

registerLocaleData(localeNl);

export const aggregatedDescription = (items: Array<string | undefined>, lastSeparator?: string) => {
    if (items.length === 0) {
        return '';
    }
    return items.reduce((previous, current, index, array) => {
        if (index === array.length - 1) {
            return `${previous}${array.length > 1 ? (lastSeparator ?? ' & ') : ''}${current}`;
        } else {
            return `${previous}${(previous?.length ?? 0) > 0 ? ', ' : ''}${current}`;
        }
    }, '');
};

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom([
            BrowserAnimationsModule,
            BrowserModule,
            ReactiveFormsModule,
            FormsModule,
            MatDialogModule,
            MatPaginatorModule,
            DateFnsModule.forRoot(),
            ClipboardModule,
        ]),
        provideRouter(routes),
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
        { provide: RouteReuseStrategy, useClass: CacheRouteReuseStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ],
});
